
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"14","height":"14"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Main_Data_user","data-name":"Main Data user","transform":"translate(-224 -605)"}},[_c('g',{attrs:{"id":"Group_29701","data-name":"Group 29701","transform":"translate(122.849 65.849)"}},[_c('rect',{attrs:{"id":"Rectangle_9038","data-name":"Rectangle 9038","width":"14","height":"14","transform":"translate(101.151 539.151)","fill":"none"}}),_c('g',{attrs:{"id":"Group_29711","data-name":"Group 29711","transform":"translate(103.151 541.151)"}},[_c('g',{attrs:{"id":"b"}},[_c('g',{attrs:{"id":"c"}},[_c('g',{attrs:{"id":"Group_29595","data-name":"Group 29595","fill":"none","stroke":"#97a0ae","stroke-linecap":"round","stroke-width":"1.2"}},[_c('path',{attrs:{"id":"d","d":"M9.2 8.2a6.812 6.812 0 00-3.845-1.126h-.016A6.708 6.708 0 001.5 8.2a2.988 2.988 0 00-.913 2.955H10.1A3 3 0 009.19 8.2","transform":"translate(-.495 -1.741)"}}),_c('path',{attrs:{"id":"e","d":"M5.877 5.667A2.586 2.586 0 103.29 3.08a2.59 2.59 0 002.587 2.587h0","transform":"translate(-1.025 -.494)"}})])])])])])])])
          )
        }
      }
    